import { ChipProps as MUIChipProps, Chip as MUIChip } from '@mui/material';
import { memo } from 'react';
import { CloseIcon } from '../../icons';
import {
  S2, S3, S5,
} from '../../theme';
import Typography, { ITypographyProps } from '../Typography';
import { mergeSX } from '../../services/helpers';

export interface IChipProps extends Omit<MUIChipProps, 'color'> {
  typographyVariant?: ITypographyProps['variant'];
  background?: string;
  iconBackground?: string;
  color?: string;
}

interface IBuildSXParams {
  background: string;
  iconBackground: string;
}

const buildSX = ({ background, iconBackground }: IBuildSXParams) => ({
  '&.MuiChip-root': {
    background,
    padding: '0 4px',
    '& .MuiChip-icon': {
      background: iconBackground,
      borderRadius: '50%',
    },
    '& .MuiChip-icon, & .MuiChip-deleteIcon': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '24px',
      minWidth: '24px',
      height: '24px',
      margin: 0,
    },
    '& .MuiChip-label': {
      padding: '0 4px',
      color: S5,
    },
  },
});

const Chip = (props: IChipProps) => {
  const {
    label,
    typographyVariant = 'body1',
    background = S2,
    iconBackground = S3,
    icon,
    color = S5,
    // 'deleteIcon' will be shown only if 'onDelete' is present
    deleteIcon = <CloseIcon width={18} height={18} color={color} />,
    sx,
    ...restProps
  } = props;

  return (
    <MUIChip
      {...restProps}
      sx={mergeSX(buildSX({ background, iconBackground }), sx)}
      label={
        <Typography color={color} variant={typographyVariant} component="span">{label}</Typography>
      }
      // "div" elements are needed so icons can get proper MUI classes
      icon={icon && <div>{icon}</div>}
      deleteIcon={<div>{deleteIcon}</div>}
    />
  );
};

export default memo(Chip);
